export default __webpack_public_path__ + "static/EA-fd0258bbc3ab064d7548d9a6d2ec37a8.jpg";